import { useCallback } from 'react';

import { useFileAttachment } from '~hooks/useFileAttachment/useFileAttachment';

import { StagedComplianceDoc } from './checklist';
import { createStagedComplianceDocuments } from './createStagedComplianceDocuments';
import { CompliantType } from './models';
import useComplianceDocuments from './useComplianceDocuments';

export function useCreateStagedComplianceDocuments(companyIdOverride?: string) {
  const { createDocument } = useComplianceDocuments(companyIdOverride);
  const { createFileAttachmentOnComplianceDocument } = useFileAttachment();

  const createStagedDocs = useCallback(
    (
      compliantType: CompliantType,
      compliantId: string,
      stagedDocs: StagedComplianceDoc[],
    ) => {
      return createStagedComplianceDocuments(
        compliantType,
        compliantId,
        stagedDocs,
        createDocument,
        createFileAttachmentOnComplianceDocument,
      );
    },
    [createDocument, createFileAttachmentOnComplianceDocument],
  );

  return { createStagedDocs };
}
